
export const blobToBase64 = (
  blob: Blob
): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
